// extracted by mini-css-extract-plugin
module.exports = {"nav":"GiftsSubNav_nav__wLLQt","link":"GiftsSubNav_link__Y1PsD","linkActive":"GiftsSubNav_linkActive__3zE9b"};